import {
  Button,
  Card,
  CardContent,
  IconButton,
  makeStyles,
  MenuItem,
  TableCell,
  TableHead,
  TableRow,
  TextField
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import CardTitle from "@saleor/components/CardTitle";
import ResponsiveTable from "@saleor/components/ResponsiveTable";
import Skeleton from "@saleor/components/Skeleton";
import {
  SortableTableBody,
  SortableTableRow
} from "@saleor/components/SortableTable";
import TableCellAvatar from "@saleor/components/TableCellAvatar";
import { InstagramLabel_instagramLabel_instagramList } from "@saleor/inslabel/types/InstagramLabel";
import { maybe, renderCollection, stopPropagation } from "@saleor/misc";
import { ReorderAction } from "@saleor/types";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
export interface LabelInstagramProps {
  productIns?: InstagramLabel_instagramLabel_instagramList[];
  onInsReorder?: ReorderAction;
  onDeleteIns?: (id: string) => void;
  onAddIns?: () => void;
  onRowClick?: (id: string) => void;
  reverseVisible: (data: InstagramLabel_instagramLabel_instagramList[]) => void;
  onInsSelectReorder?: (insId: string, sortOrder: number) => void;
}
const useStyles = makeStyles(
  theme => ({
    columnAdmin: {
      width: 100,
      textAlign: "center",
      padding: 5
    },
    columnPublished: {
      width: 120,
      textAlign: "center"
    },
    columnDrag: {
      width: 48
    },
    columnOrder: {
      width: 80,
      textAlign: "center"
    },
    columnReOrder: {
      width: 180,
      textAlign: "center",
      padding: 0,
      paddingRight: 60
    },

    columnDeleteIcon: {
      width: 80,
      textAlign: "center",
      padding: 0
    },
    columnVisible: {
      width: 80,
      textAlign: "center",
      padding: 0
    },
    columnDelete: {
      width: 80,
      textAlign: "center",
      padding: 0
    },
    columnInsImg: {
      width: "auto",
      textAlign: "center",
      padding: 0
    },
    columnUsername: {
      width: 200,
      textAlign: "center",
      padding: 0
    },

    dragIcon: {
      cursor: "grab"
    },
    iconCell: {
      "&:last-child": {
        paddingRight: theme.spacing()
      },
      width: 80
    },
    link: {
      cursor: "pointer"
    }
  }),
  { name: "AttributeValues" }
);

const LabelInstagram: React.FC<LabelInstagramProps> = ({
  productIns,
  onInsReorder,
  onDeleteIns,
  onAddIns,
  onRowClick,
  reverseVisible,
  onInsSelectReorder
}) => {
  const classes = useStyles({});
  const intl = useIntl();

  const onChangeReorder = event => {
    // eslint-disable-next-line no-console
    // console.log(event.target.value,event.target)
    const newIndex = event.target.value;
    const ins = event.target.name.split("_");
    if (newIndex && ins) {
      const insId = ins[0];
      const oldIndex = ins[1];
      onInsSelectReorder(insId, newIndex - oldIndex);
    }
  };

  return (
    <>
      <Card>
        <CardTitle
          title={intl.formatMessage({
            defaultMessage: "Content",
            description: "Content"
          })}
          toolbar={
            <Button
              color={"primary"}
              onClick={onAddIns}
              style={{ float: "right" }}
            >
              <FormattedMessage
                defaultMessage="Assign Content"
                description="button"
              />
            </Button>
          }
        ></CardTitle>
        <CardContent style={{ maxHeight: "720px", overflowY: "scroll" }}>
          <ResponsiveTable>
            <TableHead>
              <TableRow>
                <TableCell className={classes.columnDrag} />
                {/* <TableCell className={classes.columnOrder}>
                  <FormattedMessage
                    defaultMessage="Order"
                    description="Reorder header"
                  />
                </TableCell> */}
                <TableCell className={classes.columnReOrder}>
                  <FormattedMessage
                    defaultMessage="Order"
                    description="Reorder header"
                  />
                </TableCell>
                <TableCell className={classes.columnAdmin}>
                  <FormattedMessage
                    defaultMessage="ContentID"
                    description="ContentID header"
                  />
                </TableCell>
                <TableCell className={classes.columnPublished}>
                  <FormattedMessage
                    defaultMessage="Published"
                    description="published header"
                  />
                </TableCell>
                <TableCell className={classes.columnInsImg}>
                  <FormattedMessage
                    defaultMessage="Image"
                    description="Image header"
                  />
                </TableCell>
                <TableCell className={classes.columnUsername}>
                  <FormattedMessage
                    defaultMessage="Username"
                    description="Username header"
                  />
                </TableCell>

                <TableCell className={classes.columnVisible}>
                  <FormattedMessage
                    defaultMessage="Visible"
                    description="Visible header"
                  />
                </TableCell>
                <TableCell className={classes.columnDelete}>
                  <FormattedMessage
                    defaultMessage="Delete"
                    description="DeleteIcon header"
                  />
                </TableCell>
              </TableRow>
            </TableHead>
            <SortableTableBody onSortEnd={onInsReorder ? onInsReorder : null}>
              {renderCollection(
                productIns,
                (productIn, productInsIndex) => (
                  <SortableTableRow
                    className={!!productIn ? classes.link : undefined}
                    hover={!!productIn}
                    key={maybe(() => productIn.id)}
                    index={productInsIndex || 0}
                  >
                    {/* <TableCell className={classes.columnOrder}>
                  {maybe(() => productIn) ? (
                                          productInsIndex + 1
                                        ) : ''}

                  </TableCell> */}

                    <TableCell className={classes.columnReOrder}>
                      {maybe(() => productIn) ? (
                        <TextField
                          label={intl.formatMessage({
                            defaultMessage: "Reorder",
                            description: "Reorder"
                          })}
                          select
                          type="number"
                          onClick={event => event.stopPropagation()}
                          // name={"usageLimit" as keyof FormData}
                          name={productIn.id + "_" + (productInsIndex + 1)}
                          key={productIn.id + "_" + (productInsIndex + 1)} // 必须加key 不然defaultvalue一直不变
                          data-ins={productIn}
                          style={{ textAlign: "left" }}
                          defaultValue={
                            maybe(() => productIn) ? productInsIndex + 1 : ""
                          }
                          onChange={onChangeReorder}
                        >
                          {productIns.map((item, index) => (
                            <MenuItem key={item.id} value={index + 1}>
                              {index + 1}
                            </MenuItem>
                          ))}
                        </TextField>
                      ) : (
                        <Skeleton />
                      )}
                    </TableCell>

                    <TableCell
                      className={classes.columnAdmin}
                      onClick={() => {
                        onRowClick(productIn.instagram.id);
                      }}
                    >
                      {maybe(() => productIn.insId) ? (
                        productIn.insId
                      ) : (
                        <Skeleton />
                      )}
                    </TableCell>
                    <TableCell
                      className={classes.columnPublished}
                      onClick={() => {
                        onRowClick(productIn.instagram.id);
                      }}
                    >
                      {maybe(() => productIn) ? (
                        productIn.published ? (
                          "Yes"
                        ) : (
                          "No"
                        )
                      ) : (
                        <Skeleton />
                      )}
                    </TableCell>

                    <TableCellAvatar
                      className={classes.columnInsImg}
                      thumbnail={maybe(() => productIn.instagram.imageThumb)}
                      data-test="name"
                      onClick={() => {
                        onRowClick(productIn.instagram.id);
                      }}
                    />
                    <TableCell
                      style={{
                        textAlign: "center",
                        overflow: "hidden", // 超出的文本隐藏
                        textOverflow: "ellipsis", // 溢出用省略号显示
                        whiteSpace: "nowrap", // 溢出不换行
                        width: "100%"
                      }}
                    >
                      {maybe(() => productIn.userName) ? (
                        productIn.userName
                      ) : (
                        <Skeleton />
                      )}
                    </TableCell>

                    <TableCell className={classes.columnVisible}>
                      {maybe(() => productIn) ? (
                        <IconButton
                          onClick={stopPropagation(() =>
                            reverseVisible([productIn])
                          )}
                        >
                          {productIn.visible ? (
                            <VisibilityIcon color={"primary"} />
                          ) : (
                            <VisibilityOffIcon color={"secondary"} />
                          )}
                        </IconButton>
                      ) : (
                        <Skeleton />
                      )}
                    </TableCell>
                    <TableCell className={classes.columnDeleteIcon}>
                      {maybe(() => productIn) ? (
                        <IconButton
                          onClick={stopPropagation(() =>
                            onDeleteIns(productIn.id)
                          )}
                        >
                          <DeleteIcon color="primary" />
                        </IconButton>
                      ) : (
                        <Skeleton />
                      )}
                    </TableCell>
                  </SortableTableRow>
                ),
                () => (
                  <TableRow>
                    <TableCell colSpan={7}>
                      <FormattedMessage
                        defaultMessage="No Content found"
                        description="No Content found"
                      />
                    </TableCell>
                  </TableRow>
                )
              )}
            </SortableTableBody>
          </ResponsiveTable>
        </CardContent>
      </Card>
    </>
  );
};

export default LabelInstagram;
